/**
 * @file: info-column.tsx
 *
 * Desktop column 3 — the chat room detail (members + settings). Keyed by
 * room id + an invite nonce so an invite forces a remount + member refetch.
 */

import {
  ChatConversationHandle,
  conversationHandleKey,
} from '@euler/app/flows/chat/lib/conversation/handle';
import { ChatContactPickerParams } from '@euler/app/flows/chat/lib/types';
import { ChatRoomDetailView } from '@euler/app/flows/chat/pages/room-detail';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { StyleSheet, View } from 'react-native';

export const InfoColumn: FC<{
  handle: ChatConversationHandle;
  nonce: number;
  onAddMembers: (params: ChatContactPickerParams) => void;
  onClose: () => void;
  /** Leave/dismiss/delete succeeded — host closes the pane AND deselects the
   * (now-gone) conversation. */
  onExit: () => void;
}> = memo(({ handle, nonce, onAddMembers, onClose, onExit }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        width: rpx(320),
        borderLeftWidth: StyleSheet.hairlineWidth,
        borderLeftColor: '#ececec',
        backgroundColor: '#f5f5f5',
      }}
    >
      <ChatRoomDetailView
        key={`${conversationHandleKey(handle)}:${nonce}`}
        handle={handle}
        embedded
        onAddMembers={onAddMembers}
        onClose={onClose}
        onExit={onExit}
      />
    </View>
  );
});
